import { CheckInSummary } from "../../models/checkInSummary";
import { CheckInStatusBadge } from "../common/checkInStatusBadge";
import { useTranslation } from "react-i18next";
import { decode } from "html-entities";

interface EventListCellProps {
  eventSummary: CheckInSummary;
}
export function CheckInListCell({ eventSummary }: EventListCellProps) {
  const { t } = useTranslation();
  return (
    <>
      <div className={"flex items-center px-2 py-3 gap-5"}>
        <label className={"text-xs"}>{eventSummary.eventId}</label>
        <div className={"flex flex-col flex-1 gap-2 min-w-0"}>
          <div
            className={"flex gap-2 justify-between flex-1 flex-col xs:flex-row"}
          >
            <label className={"text-sm"}>
              {eventSummary.eventStartAt?.format(t("datetimesec_format"))}
            </label>
            <CheckInStatusBadge eventStatus={eventSummary.status} />
          </div>
          <label className={"truncate"}>{decode(eventSummary.title)}</label>
          <label className={"text-[0.870rem] text-gray-400 truncate"}>
            {decode(eventSummary.rewardName) || "-"}
          </label>
        </div>
      </div>
    </>
  );
}
